export default {
  title: 'השירות שלנו',
  paragraphs: {
    first: 'פולאריס פמילי אופיס מעניקה ללקוחותיה מגוון שירותים בתחום ניהול העושר, המספקים פתרון מלא ומאפשרים לכל לקוח לנהל ולשלוט על כל עולמו הפיננסי והכלכלי במקום אחד.',
    second: 'בין סל השירותים שמעניקה החברה: אלוקציית השקעות, תכנון פיננסי, ניהול ובקרה שוטפים, תכנוני מס, ניהול סיכונים, תכנון העברה בין-דורית, תכנון הפרישה ועוד.',
    third: 'אנו מספקים דרך אתר ייעודי דיווח אישי המתעדכן אחת לחודש ומרכז את כל המידע במקום אחד וכך מאפשר ללקוח הבנה, שליטה, מעקב ובקרה אודות ההתפתחות של התיק שכולל את כל הנכסים.',
    fourth: 'לקוחותינו זוכים לליווי אובייקטיבי ומקצועי, דיסקרטיות, יחס אישי וגישה להשקעות בארץ ובעולם.',
  },
};
